import { useLocation, useNavigate } from 'react-router-dom';
import { Box } from '@mui/material';
import { t } from 'i18next';

import CloudCross from '~/assets/icons/errors/cloud-cross.svg?react';
import LogoImg from '~/assets/icons/logo.webp';
import { Text } from '~/components/ui/text';
import { PATH } from '~/constants/route-path';

export function LimitReached() {
  const navigate = useNavigate();

  const handleNavigateToMain = () => {
    const host = window.location.host;

    if (host.includes('staging')) {
      host.includes('staging.qrbrain.io') ? navigate(PATH.QR.MAIN) : window.open('https://staging.qrbrain.io/');
    } else if (host.includes('qrbrain')) {
      host.includes('qrbrain.io') ? navigate(PATH.QR.MAIN) : window.open('https://qrbrain.io/');
    }
  };

  return (
    <Box
      sx={{
        height: '100vh',
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        position: 'relative',
        padding: '70px 38px',
      }}
    >
      <CloudCross style={{ width: 220, height: 220 }} />

      <Box textAlign="center" sx={{ marginTop: '32px' }}>
        <Text variant="h1.7">{t('errorPages:limitReached')}</Text>
      </Box>

      <Box
        position="absolute"
        bottom="3%"
        onClick={handleNavigateToMain}
        sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '12px', cursor: 'pointer' }}
      >
        <Text variant="button12Medium">{t('errorPages:poweredBy')}</Text>
        <Box display="flex" alignItems="center">
          <img src={LogoImg} alt="Qr Brain logo" width={128} height={30} />
        </Box>
      </Box>
    </Box>
  );
}
